<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">选择日期：</span>
        <el-date-picker 
          v-model="dutyDate" 
          type="date" 
          clearable
          value-format="yyyy-MM-dd"
          placeholder="请选择日期">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" @click="searchDutyManageList(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dutyList"
        height="100%" >
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dutyDate" label="值班日期" align="center"></el-table-column>
        <el-table-column prop="dutyUserName" label="值班人员" align="center"></el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="dutyContent" label="值班内容" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增值班信息 修改值班信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增值班' : '修改值班信息'"
      :visible.sync="asyncDuty"
      width="35%">
      <el-form ref="form" :model="formDuty" :rules="rulesDuty" label-width="auto" class="rule_form">
        <el-form-item label="值班日期：" prop="dutyDate">
          <el-date-picker 
            v-model="formDuty.dutyDate" 
            type="date"
            :size="size"
            clearable
            value-format="yyyy-MM-dd"
            placeholder="请选择值班日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="值班人员：" prop="dutyUser">
          <el-select v-model="formDuty.dutyUser" :size="size" clearable placeholder="请选择值班人员">
            <el-option
              v-for="item in staffData"
              :key="item.userId"
              :label="item.realName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input v-model="formDuty.phone" :size="size" clearable placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="值班内容：" prop="dutyContent">
          <el-input 
            type="textarea" 
            v-model="formDuty.dutyContent"
            clearable
            placeholder="请输入值班内容"
            :size="size"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input 
            type="textarea" 
            v-model="formDuty.remark"
            clearable
            placeholder="请输入备注"
            :size="size"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncDuty = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from "../../pinia/index";
import { changeSize, throttle } from "../../plugins/public";
  export default {
    data() {
      return {
        size: changeSize(),
        dutyDate: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        dutyList: [], // 列表信息
        asyncTitle: true, // true 添加值班信息 false 修改值班信息
        asyncDuty: false, // 弹窗
        formDuty: {}, // 表单信息
        rulesDuty: {
          dutyDate: [{
            required: true,
            message: '请选择值班日期',
            trigger: ['change', 'blur']
          }],
          dutyUser: [{
            required: true,
            message: '请选择值班人员',
            trigger: ['change', 'blur']
          }],
          phone: [{
            required: true,
            message: '请输入值班人员电话',
            trigger: 'blur'
          }, {
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }],
          dutyContent: [{
            required: true,
            message: '请输入值班内容',
            trigger: 'blur'
          }]
        }, // 校验规则
        staffData: [], // 值班人员信息
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchDutyManageList(true);
    },
    methods: {
      // 获取所有人员信息
      async getAllStaffData() {
        const { data } = await this.$api.Personnerl.GETSTAFFALLDATA();
        this.staffData = data;
      },
      // 查询值班管理信息
      searchDutyManageList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.dutyList = [];
        this.$api.Personnerl.SEARCHDUTYMANAGELIST({
          dutyDate: this.dutyDate,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.dutyList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncDuty = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncDuty = true;
        this.$set(this.formDuty, 'dutyId', row.dutyId);
        this.$set(this.formDuty, 'dutyDate', row.dutyDate);
        this.$set(this.formDuty, 'dutyUser', row.dutyUser);
        this.$set(this.formDuty, 'dutyContent', row.dutyContent);
        this.$set(this.formDuty, 'phone', row.phone);
        this.$set(this.formDuty, 'remark', row.remark);
      },
      // 删除值班信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该值班信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Personnerl.DATEDUTYMANAGEINFO({dutyId: row.dutyId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchDutyManageList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDuty);
            this.$api.Personnerl.INSERTDUTYMANAGEINFO(params).then((res) => {
              if(res.success) {
                this.asyncDuty = false;
                this.searchDutyManageList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDuty);
            this.$api.Personnerl.UPDATEDUTYMANAGEINFO(params).then((res) => {
              if(res.success) {
                this.asyncDuty = false;
                this.searchDutyManageList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchDutyManageList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchDutyManageList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncDuty(bol) {
        if(!bol) {
          this.formDuty = {};
          this.$refs.form.resetFields();
        } else {
          this.getAllStaffData();
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>